var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Fragment',[_c('Sidedraw'),_c('Header'),_c('main',{staticClass:"content",style:({ marginTop: _vm.calcMargin })},[_vm._t("default")],2),_c('ModalMobile'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }